import { Image } from "@chakra-ui/react";
import HtmlIcon from "./html.svg";
interface Props {
  color?: string;
  boxSize?: string;
}
export const Html = (props: Props) => <Image boxSize={props.boxSize} src={HtmlIcon} />;

export default Html;
